var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeedoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 10.4492C0.324219 4.92637 4.80137 0.449219 10.3242 0.449219H38.3242C43.8471 0.449219 48.3242 4.92637 48.3242 10.4492V38.4492C48.3242 43.9721 43.8471 48.4492 38.3242 48.4492H10.3242C4.80137 48.4492 0.324219 43.9721 0.324219 38.4492V10.4492Z",
    fill: "url(#paint0_linear_4168_5943)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3242 26.4492C32.8142 24.9892 34.3242 23.2392 34.3242 20.9492C34.3242 19.4905 33.7448 18.0916 32.7133 17.0601C31.6819 16.0287 30.2829 15.4492 28.8242 15.4492C27.0642 15.4492 25.8242 15.9492 24.3242 17.4492C22.8242 15.9492 21.5842 15.4492 19.8242 15.4492C18.3655 15.4492 16.9666 16.0287 15.9351 17.0601C14.9037 18.0916 14.3242 19.4905 14.3242 20.9492C14.3242 23.2492 15.8242 24.9992 17.3242 26.4492L24.3242 33.4492L31.3242 26.4492Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.543 24.4492H21.823L22.323 23.4492L24.323 27.9492L26.323 20.9492L27.823 24.4492H33.093",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5943",
    x1: 24.3242,
    y1: 0.449219,
    x2: 24.3242,
    y2: 48.4492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedoc);
export default __webpack_public_path__ + "static/media/Seedoc.7fab6d5666648489eba244adab3122bb.svg";
export { ForwardRef as ReactComponent };